module.exports = __webpack_public_path__ + "static/img/Edward.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/christmasPC-2019/Edward.png
// module id = G0wh
// module chunks = 1